import { useRouter } from "next/router";
import { useMemo } from "react";

/**
 * @param {string} key
 * @returns {number | undefined}
 */
export default function useRouterNumber(key) {
  const router = useRouter();

  const value = useMemo(() => {
    return typeof router.query[key] === "string"
      ? isNaN(Number(router.query[key]))
        ? undefined
        : Number(router.query[key])
      : undefined;
  }, [key, router.query]);

  return value;
}
